import { PrimaryButton } from "@fluentui/react";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";

export const ApplyButton = () => {
  const { onClickApply, strings, id } = useContext(ColumnOptionsContext);

  return (
    <PrimaryButton
      id={id ? `${id}-btn-apply` : undefined}
      iconProps={{ iconName: "Sync" }}
      onClick={onClickApply}
      text={strings.applyButtonLabel}
    />
  );
};
